import { qportalApi } from './qportal-api';
const getCountries = async () => {
    return await qportalApi.get('countries');
};
const CountryApi = {
    getCountries
};
export default CountryApi;
